import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CamDataBuilder } from '../../models/builders/cam-data.builder';
import { CamSoftwareBuilder } from '../../models/builders/cam-software.builder';

const getCamBody = (cam: string, file: File, material: string, part: string, manufacturingOrder: string) => {
  const postBody = new FormData();
  postBody.append('cam', cam);
  postBody.append('file', file);
  postBody.append('material', material);
  postBody.append('part', part);
  postBody.append('manufacturingOrder', manufacturingOrder);

  return postBody;
};

@Injectable()
export class CamApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}cams`;
  }

  getCamSoftwares() {
    return this.httpClient.get(`${this.apiUrl}/softwares`)
      .pipe(
        map(CamSoftwareBuilder.fromList)
      );
  }

  getPdf(cam: string, file: File, material: string, part: string, manufacturingOrder: string) {
    return this.httpClient.post(
      `${this.apiUrl}/pdf`,
      getCamBody(cam, file, material, part, manufacturingOrder),
      { responseType: 'arraybuffer' }
    );
  }

  loadCam(cam: string, file: File) {
    const postBody = new FormData();
    postBody.append('file', file);
    postBody.append('cam', cam);

    return this.httpClient.post(`${this.apiUrl}/extract`, postBody)
      .pipe(
        map(CamDataBuilder.fromJson)
      );
  }

  validateSaveCam(cam: string, file: File, material: string, part: string, manufacturingOrder: string) {
    return this.httpClient.post(`${this.apiUrl}/validate`, getCamBody(cam, file, material, part, manufacturingOrder))
      .pipe(
        map(CamDataBuilder.camDataValidationFromJson)
      );
  }

  saveCam(cam: string, file: File, material: string, part: string, manufacturingOrder: string) {
    return this.httpClient.post<{ schedulerTasks: String[] }>(`${this.apiUrl}`, getCamBody(cam, file, material, part, manufacturingOrder))
      .pipe(
        map(data => data.schedulerTasks)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/cam-api.service.ts